<template>
  <label class="custom-checkbox">
    <input
      type="checkbox"
      hidden
      v-bind="attrs"
      :id="safeId"
      :checked="modelValue"
      @change="handleChange"
      :disabled="disabled"
    />
    <span class="checkmark flex-center" :class="markClass">
      <CheckBold class="check-icon" :size="iconSize" v-if="!!modelValue" />
    </span>
    <span v-if="label" class="checkbox-label">
      <span v-if="required" class="required">[{{ $t('labels.required') }}]</span>
      <span>{{ label }}</span>
    </span>
  </label>
</template>

<script>
import { sharedComputedProps } from '@/mixins/formMixins';
import CheckBold from 'vue-material-design-icons/CheckBold';

export default {
  name: 'ReCruiseCheckbox',
  mixins: [sharedComputedProps],
  emits: ['update:modelValue', 'onChange'],
  components: { CheckBold },
  props: {
    label: String,
    modelValue: Boolean,
    disabled: Boolean,
    required: Boolean,
    iconSize: {
      type: Number,
      default: 14,
    },
  },
  computed: {
    markClass() {
      return [{ checked: !!this.modelValue, disabled: this.disabled }];
    },
  },
  methods: {
    handleChange(e) {
      this.$emit('update:modelValue', e.target.checked);
      this.$emit('onChange', e);
    },
  },
};
</script>

<style scoped>
.custom-checkbox {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 14px;
  user-select: none;
}

.checkmark {
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  border-radius: 2.5px;
  border: 1px solid var(--Disabled, #9299a0);
}

.checkmark.checked {
  border: 1px var(--Blue-blue-500, #446ceb);
  background: var(--Blue-blue-500, #446ceb);
}

.checkmark.disabled {
  cursor: default;
  border: 1px solid var(--Grey-grey-100, #dddfe2);
}

.checkmark.checked.disabled {
  border: 1px var(--Blue-blue-100, #c5d1f9);
  background: var(--Blue-blue-100, #c5d1f9);
}

.check-icon {
  color: var(--White);
}

.checkbox-label {
  display: inline-flex;
  align-items: center;
}

.required {
  display: inline-block;
  color: var(--Blue-blue-500);
  font-size: 16px;
  font-weight: 600;
  line-height: 100%;
  letter-spacing: -1.5px;
  margin-right: 4px;
  /* padding-top: 2.5px; */
}

@media screen and (min-width: 768px) {
  .required {
    font-size: 18px;
  }
}
</style>
